import Module from 'mini-common-schema/lib/schema/Module';
import selectFolderWithFallback from '../utils/selectFolderWithFallback';
import switchModule from 'owa-mail-store/lib/actions/switchModule';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import { targetedAdLgpdDismissed } from 'mini-lgpd-opt-in/lib/utils/targetedAdUtils';
import { targetedAdV3Dismissed } from 'mini-gdprv3-ads-opt-in/lib/utils/targetedAdUtils';
import { targetedEUAdsDismissed } from 'owa-euemailads-optin/lib/utils/targetedAdUtils';

export interface MailFolderRouteParameters {
    folderId: string;
}

// Handle folderId route
export function mailFolderRouteHandler(params: MailFolderRouteParameters) {
    // When we reach a mail folder route, switch selected module to mail so that mail list view is rendered
    targetedEUAdsDismissed();
    targetedAdLgpdDismissed();
    targetedAdV3Dismissed();
    switchModule(Module.Mail);
    selectFolderWithFallback(params.folderId);
}

export function mailFolderCleanupRouteHandler(
    oldRoute: string[],
    oldParams: any,
    newRoute: string[],
    newParams: any
) {
    // We are using react router for upNext event details and the subsequent routes.
    // Since these routes are pushed not via getCurrentRoute, owa-router goes out of sync with the actual route.
    // So whenever any browser navigation (back or forward) in these routes owa-router listener will get triggered
    // and calls mailFolderCleanupRouteHandler because this is the route it thinks we are in.
    // So allow navigation in this case.
    if (newRoute.includes('event')) {
        return false;
    }

    // if we are in a hosted environment, align with the browser back behavior.
    if (isMiniHostAppFeatureEnabled('native')) {
        return false;
    }

    // Always block back/forward button from list view as it is the default view.
    return true;
}
